import React, {useCallback} from 'react';
import styled from 'styled-components';
import {FormRadio} from '../../../atoms/form/radio';
import {RadioWrapper} from './ui';

interface CommentReaction {
    key: string;
    label: string;
    colors: {dark: string; light: string};
}

export interface CommentsSortByReactionProps {
    items: CommentReaction[];
    className?: string;
    activeKey?: string;
    onChange?: (key: string) => void;
}

export const RawCommentsSortByReaction: React.FC<CommentsSortByReactionProps> = ({items, activeKey, onChange, className}) => {
    const onChangeHandler = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
        if (typeof onChange === 'function') {
            onChange(e.target.value);
        }
    }, [onChange]);

    return (
        <RadioWrapper className={className}>
            {items.map((reaction) => (
                <FormRadio
                    key={reaction.key}
                    onChange={onChangeHandler}
                    checked={reaction.key === activeKey}
                    name="sortBy"
                    value={reaction.key}
                    label={reaction.label}
                    color={reaction.colors.light}
                />
            ))}
        </RadioWrapper>
    );
};

export const CommentsSortByReaction = styled(RawCommentsSortByReaction)``;
